import React from "react";
import { useSearch } from "~/context/SearchContext";
import SidebarSubHeading from "./SidebarSubHeading";
import SidebarLabel from "./SidebarLabel";
import type { SearchArea, SearchAreaCategories } from "~/types";

type Props = {
  searchAreas: SearchArea[];
  searchAreaCategories: SearchAreaCategories;
};

const SearchAreaSection: React.FC<Props> = ({
  searchAreas,
  searchAreaCategories,
}) => {
  const {
    conditions: selectedConditions,
    addCondition: handleAddCondition,
    removeCondition: handleSubCondition,
  } = useSearch();

  const getCategoryAreas = (categoryId: string) => {
    return searchAreas.filter(
      (area) => area.search_area_category_id === categoryId
    );
  };

  return (
    <div className="[&>div]:my-1">
      {Object.values(searchAreaCategories).map((category) => {
        const categoryAreas = getCategoryAreas(category.id);
        return (
          <React.Fragment key={category.key}>
            <SidebarSubHeading text={category.name} />
            {category.key === "tokyo" && (
              <SidebarLabel
                text="東京都全域"
                type="search_area_ids"
                value={categoryAreas.map((area) => area.id)}
              />
            )}
            {categoryAreas.map((area) => (
              <SidebarLabel
                key={area.id}
                text={area.name}
                type="search_area_ids"
                value={area.id}
              />
            ))}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default SearchAreaSection;
